import styles from './PostsNoDataLabel.module.css';
import { Button, assets } from '@round/whitelabel-ui';

const { Plus: PlusIcon, UserPlus: UserPlusIcon } = assets;

type Props = {
    hasError: boolean;
    isReadOnly?: boolean;
    onAddPost?: () => void;
    onAddCreators?: () => void;
};

const PostsNoDataLabel = ({ onAddPost, onAddCreators, hasError, isReadOnly = false }: Props) => {
    return (
        <div className={styles.container} aria-label="no posts">
            {hasError ? (
                'Could not load posts'
            ) : !isReadOnly && (onAddPost || onAddCreators) ? (
                <>
                    {onAddPost && (
                        <Button
                            className={styles.button}
                            appearance="primary"
                            onClick={onAddPost}
                            iconLeft={<PlusIcon className={styles.plusIcon} />}
                        >
                            Post
                        </Button>
                    )}

                    {onAddCreators && (
                        <Button
                            className={styles.button}
                            appearance="primary"
                            onClick={onAddCreators}
                            iconLeft={<UserPlusIcon className={styles.userPlusIcon} />}
                        >
                            Creators
                        </Button>
                    )}
                </>
            ) : (
                'No posts yet'
            )}
        </div>
    );
};

export default PostsNoDataLabel;
